import React from 'react';

import CancelIcon from '@mui/icons-material/Cancel';
import { Control } from 'react-hook-form';

import { IconButton, LbInput } from '@infoods/lifebase-ui';

import classes from './EditFaqRow.module.scss';
import { FormFieldsGrid } from '../../FormFieldsGrid/FormFieldsGrid';
import { ChallengeFormValues } from '../../../../interfaces/ChallengeFormValues';
import { RichTextEditor } from '../../../../../shared/features/rich-text';
import {
  validateWhitespace,
  validateRichTextWhitespace,
} from '../../../../../shared/utils/reactHookFormUtils';

type EditFaqRowProps = {
  index: number;
  control: Control<ChallengeFormValues>;
  onRemove: (index: number) => void;
  showRemoveButton: boolean;
};

export const EditFaqRow = ({
  index,
  control,
  onRemove,
  showRemoveButton,
}: EditFaqRowProps) => {
  const generalInputProps = {
    control,
    size: 'small',
  } as const;

  return (
    <FormFieldsGrid>
      <div className={classes.faqLabel}>Question {index + 1}</div>
      <div className={classes.fieldColumns}>
        <div className={classes.inputBox}>
          <LbInput
            {...generalInputProps}
            name={`faqs.faqs.${index}.question`}
            label="Question"
            rules={{
              required: 'Question is required',
              validate: { validateWhitespace },
            }}
          />
          <RichTextEditor
            {...generalInputProps}
            name={`faqs.faqs.${index}.answer`}
            label="Answer"
            rules={{
              required: 'Answer is required',
              validate: { validateRichTextWhitespace },
            }}
          />
        </div>
        {showRemoveButton && (
          <IconButton
            onClick={() => onRemove(index)}
            color="tertiary"
            aria-label={`Remove FAQ ${index + 1}`}
          >
            <CancelIcon />
          </IconButton>
        )}
      </div>
    </FormFieldsGrid>
  );
};
